module.exports = __webpack_public_path__ + "img/4.8972c31b.png";